import Image from './Image' // Import the Image subcomponent
import Box from '@mui/material/Box'

const ImageListSelector = ({ images, onClick, value }) => {
  // Handle image click event

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start', // Align children (images) to the left
        alignItems: 'center', // Vertically align in the center (optional)
        gap: 2, // Add space between images
      }}
    >
      {images.map((image, index) => (
        <Image
          key={index}
          src={image.src}
          alt={image.alt}
          isSelected={image.alt === value}
          onClick={() => onClick(image.alt)}
        />
      ))}
    </Box>
  )
}

export default ImageListSelector
